export default "assets/images/icons/triangles-5487862d.svg";